export enum NavigationEvent {
  BACK = 'BACK',
  FORWARD = 'FORWARD',
}

export type NavigationEventSchema =
  | {type: NavigationEvent.BACK}
  | {type: NavigationEvent.FORWARD};
